export default "__VITE_ASSET__5526b614__"